<template>
  <mw-dialog ref="dialog" :appendToBody="false" :title="$lang('查看操作记录')" size='large_large' customClass='mw-form-view-dialog'>
    <div class="mw-margin-top-10 process-dialog">
      <!--<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="按时间" name="first">-->
          <mw-table :api="api" :columns="columns" :pagination="false"
                    :nowrap="false"  :defaultParams="defaultParams" :defaultParamsAutoLoad="true">
           <!-- <template slot="description" slot-scope="scope">
              <div v-html="scope.row.description"> </div>
            </template>-->
          </mw-table>
        <!--</el-tab-pane>
      </el-tabs>-->
    </div>
  </mw-dialog>
</template>
<script>

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me = this;

    return {
      activeName: 'first',
      api:'/s:business.srv.listFlowLog',
      defaultParams:{batchId:this.params.batchId},
      columns: [
        {type: "index" },
        {prop: 'createTime', label: $lang('操作时间'),width: '160'},
        {prop: 'operator',tooltip:true, label: $lang('用户名'),width:'80'},
        {prop: 'actionName',tooltip:true,label:$lang('操作类型'),width:'80'},
        {prop: 'description',tooltip:true,label:$lang('操作说明'),slot: {type: 'html',func:function(){}}},
        {prop: "accessType", label: $lang("客户端类型"),width:'90'},
        {prop: 'ip',label: $lang('客户端IP'),width: '118'}
      ]
    };
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
  },
  watch: {
    params(val) {
      this.activeName='first';
      this.defaultParams={batchId:val.batchId};
    },
  },
  methods: {
    dateFormatter(row, col, cellValue){
        if(cellValue){
          return cellValue.substring(2,cellValue.lastIndexOf(':'));
        }
        return '';
    },
    statusFormatter(row, col, cellValue){
        if(row.finishTime){
          return '<'+cellValue+'>';
        }
        return cellValue;
    },
    oprrecordFormatter(row, col, cellValue){
     if(!cellValue){
        return '';
     }

     var coms = cellValue.map(d => {
       return (
         <li>
           {d.createTime.substring(2,d.createTime.lastIndexOf(':'))+' '+d.operator+' '+d.actionName+ (d.description?': '+d.description:'')}
         </li>
       );
     })
     return <span>  {coms} </span>;
    },
    handleClick(tab, event) {

    },
    show(){
        this.mwRef('dialog').show();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/process-operationRecord.vue